import React, { FunctionComponent, useEffect } from 'react';

import { AlertType } from '../../types';
import { ButtonVariantEnum } from '../../enums';
import { FaTimes } from 'react-icons/fa';
import { IconButton } from '..';
import { useAlert } from '../../hooks';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const Alerts: FunctionComponent = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const { alerts, clearAlerts, removeAlert } = useAlert();

  useEffect(() => {
    clearAlerts();
  }, [location.pathname]);

  return alerts.length > 0 ? (
    <div className="container">
      {alerts.map((alert: AlertType) => {
        const Icon = alert.type.icon;
        return (
          <div
            className={`alert alert-${alert.type.class} d-flex align-items-center mt-2 mb-1`}
            role="alert"
            key={`${alert.message}-${alert.type.class}`}
          >
            <Icon size="1.25em" className="align-middle" />
            <div className="w-100 d-flex align-items-center">
              <div className="ms-2" dangerouslySetInnerHTML={{ __html: alert.message }}></div>
            </div>
            <div className="flex-shrink-1">
              <IconButton
                Icon={FaTimes}
                onClick={() => {
                  removeAlert(alert);
                }}
                variant={`${alert.type.class}` as ButtonVariantEnum}
                title={t('label.fechar')}
                className={`alert-${alert.type.class}`}
                circle
                noBorder
              />
            </div>
          </div>
        );
      })}
    </div>
  ) : null;
};

export default Alerts;
